import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'

export class EmailService extends BaseService {
  static async listMail(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.integ.email.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async reSendEmail(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.integ.email.resend'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
